<div class="card bg-white dark:bg-gray-950">
  <div class="card-header bg-gray-100 dark:bg-gray-750 text-blue dark:text-white">
    <ng-content select="[header]"></ng-content>
  </div>

  <div class="overflow-hidden h-full w-full rounded-b">
    @if (!loadingValue$) {
      @if (!noDataFoundValue$) {
        <ng-content select="[body]"></ng-content>
      } @else {
        <app-no-data-message [customMessage]="noDataMessage ?? null"></app-no-data-message>
      }
    } @else {
      <div class="py-3">
        <app-loader-small></app-loader-small>
      </div>
    }
  </div>
</div>


